import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";

const BarLineLineChartV2 = (props) => {

  const symbol = props.symbol || '';
  const getOptions = () => ({
    title: {
      text: props.title,
      subtext: props.subTitle,
      left: 'center'
    },
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      orient: 'horizontal',
      left: 'center',
      top: 'bottom'
    },

    grid: {
      top: '15%', // Espacio superior
      left: '10%', // Espacio izquierdo
      right: '10%', // Espacio derecho
      bottom: '30%', // Aumenta este valor para dar más espacio en la parte inferior
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: props.categories,
      axisLabel: {
        rotate: 30,
        interval: 0,
        textStyle: {
          fontSize: 12,
          color: '#333',
        }
      }
    },
    yAxis: [
      {
        type: 'value',
        name: props.nameBar,
        position: 'left'
      },
      {
        type: 'value',
        name: props.nameLine,
        position: 'right'
      }
    ],
    series: [
      {
        name: props.nameBar,
        type: 'bar',
        data: props.applications, // Datos para las barras (ej. total de frutos)
        label: {
          show: true,
          position: 'inside',
          formatter: (params) => {
            return new Intl.NumberFormat('es-CO', {
              minimumFractionDigits: 0, // Mínimo de decimales
              maximumFractionDigits:  0, // Máximo de decimales
            }).format(params.value) + symbol;
          }
        }
      },

      {
        name: props.nameLine,
        type: 'line',
        smooth: true,
        yAxisIndex: 1,
        data: props.hectares,

        label: {
          show: true,
          position: 'top',

          formatter: (params) => {
            return new Intl.NumberFormat('es-CO', {
              minimumFractionDigits: props.decimals ?? 0,
              maximumFractionDigits: props.decimals ?? 0,
            }).format(Number(params.value)) + symbol;
          },

          textStyle: {
            color: '#000',
            fontSize: 10,
            fontWeight: 'regular',
            shadowBlur: 2,
            shadowColor: 'rgba(12, 12, 12, 0.7)',
          }
        },

        lineStyle: {
          color: '#ff7f50',
          width: 3,
        }
      }

      ,

      {
        name: props.nameLine2,
        type: 'line',
        smooth: true,
        yAxisIndex: 1, // Asocia esta serie con el segundo eje Y (derecho)
        data: props.days, // Datos para la línea (ej. hectáreas recorridas)
        label: {
          show: true,
          position: 'top',
          offset: [0, 2],
          textStyle: {
            color: '#000', // Color del texto
            fontSize: 10,
            fontWeight: 'bold',
            shadowBlur: 2, // Desenfoque de sombra
            shadowColor: 'rgba(12, 12, 12, 0.7)', // Color de la sombra (blanco con algo de transparencia)
          }
        },
        lineStyle: {
          color: '#82d8e4', // Color de la línea
          width: 3,
        }
      }


    ]
  });

  return (
    <div className="">
      <ReactEcharts
        ref={props.chartRef}
        option={getOptions()}
        style={{ height: 300 }}
      />
    </div>
  );
};

export default BarLineLineChartV2;
